





















































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IExport from '@/components/icons/IExport.vue'
import IArrow from '@/components/icons/IArrow.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')


@Component({
  components: {
    BtnDefault,
    'i-export': IExport,
    'i-arrow': IArrow,
   }
})

export default class SelectedProduct extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  @Prop({type: [Boolean], default: false}) protected isSelectedProduct!: boolean
  @Prop({type: [Object], default: {}}) protected currentProduct!: any

  scroll:boolean = false
  panel:any = [0, 1, 2]

  exportAll() {
    this.$emit('exportAll')
  }

  addProduct() {
    this.setOptions()
    this.SetTitleDialog(this.$t('products.add.title'))
    this.SetFormSDialog('AddProductForm')
    this.SetFullDialogShow(true)
  }

}
